export default {
  description: 'Descrição',
  email: 'Email',
  password: 'Senha',
  confirm_password: 'Confirmar Senha',
  name: 'Nome',
  image: 'Imagem',
  roles: 'Perfis',
  date: 'Data',
  initialDate: 'Data Inicial',
  finalDate: 'Data Final',
  created_at: 'Criado em',
  updated_at: 'Atualizado em',
  status: 'Status',
  userProject: 'Usuário',
  projects: 'Projetos',
  server: {
    host: 'Host',
    ip: 'IP',
    database: 'Banco de Dados',
    port: 'Porta',
  },
  user: {
    id: 'Código',
    name: 'Nome',
    email: 'Email',
    remember_token: 'Token',
    created_at: 'Criado em',
    updated_at: 'Atualizado em',
    image: 'Imagem',
    client: 'Cliente Vinculado',
    perfil: 'Perfil',
    status: 'Status',
  },
  client: {
    name: 'Cliente',
    cnpj: 'CNPJ',
    status: 'Status',
  },
  cycle: {
    start_date: 'Data de Início',
    end_date: 'Data do Fim',
    note: 'Observação',
    status: 'Status',
    qtd_hours: 'Quantidade de Horas',
  },
  task: {
    id: 'Código',
    description: 'Descrição',
    done: 'Feito?',
    priority: 'Prioridade',
    scheduled_to: 'Agendado Para',
    project: 'Projeto',
    project_id: 'Projeto',
    created_at: 'Criado em',
    updated_at: 'Atualizado em',
  },
  call: {
    id: 'Código',
    type_call: 'Tipo',
    destination_call: 'Destino',
    origin_call: 'Origem',
    date_call: 'Data/Hora',
    duration_call: 'Duração',
  },
  project: {
    responsible_name: 'Nome do Responsável',
    responsible_email: 'Email do Responsável',
    responsible_tel: 'Telefone do Responsável',
    status: 'Status',
  },
  called: {
    title: 'Título',
    project: 'Projeto',
    priority: 'Prioridade',
    cycle: 'Ciclo',
    number: 'Nº',
    user_created: 'Criado por',
    cycle_status: 'Status do Ciclo',
    createBy: 'Criado Por',
  },
  event: {
    event_type: 'Tipo',
    date: 'Data do Evento',
  },
  table_manager: {
    table_name: 'Nome da Tabela',
    created_by: 'Criado Por',
    users: 'Usuários Associados',
  },
  billing_report: {
    client: 'Cliente',
    hours_performed: 'Horas Executadas',
    billed_hours: 'Horas Faturadas',
    authorized_by: 'Autorizado Por',
    cycle: 'Ciclo',
    cycle_status: 'Status do Ciclo',
  },
  zoho: {
    client_id: 'Client ID',
    client_secret: 'Client Secret',
    refresh_token: 'Refresh Token',
    email: 'Email',
    db_name: 'Workspace',
    table_name: 'Nome da Tabela',
  },
  load_conf: {
    project: 'Projeto',
    description: 'Descrição',
    periodicity: 'Periodicidade',
    qtd_periodicity: 'Por Período',
    active: 'Ativo',
    types: 'Tipos',
  },
  // é carregado do servidor caso esteja definido no mesmo
  auditModel: {
  },
};



// WEBPACK FOOTER //
// ./src/i18n/pt-BR/Attributes.js